export default __webpack_public_path__ + "docker.50584ca4.png";